import MainParticipantInfo from '../MainParticipantInfo/MainParticipantInfo';
import ParticipantTracks from '../ParticipantTracks/ParticipantTracks';
import React from 'react';
import { useVideoContext } from '../../main';
export default function MainParticipant(props) {
    const { room: { localParticipant } } = useVideoContext();
    return (React.createElement(MainParticipantInfo, { participant: localParticipant },
        React.createElement(ParticipantTracks, { participant: localParticipant, disableAudio: true, disableVideo: props.disableVideo, videoPriority: 'high' })));
}
//# sourceMappingURL=MainParticipant.js.map